
const sx = () => {
    const css = {
        submitButton: {
            backgroundColor: '#D89274',
            color: '#fff',
        },
        page: {
            backgroundColor: '#FFFFFF !important',
        }
    }

    return { css } 
}

export { sx }